module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-apache-02-m-en.7ef279fdb676c2bc6b2dd5e2e941254d.png";